import * as React from "react";
import { Button } from "reactstrap";
import i18n from "i18next";
import { ListViewComponent } from "@syncfusion/ej2-react-lists";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';

import "./eventtype.scss";

export class FilterEventtype extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        allSelected: this.props.filterEventType.length === this.props.eventTypes.length + 2,
        eventTypeData: []
    };
    this.defaultEventTypeData = [        
        {
            id: 0,
            text: "Otros tipos de eventos",
            isChecked: this.props.filterEventType?.includes("Otros tipos de eventos")
        },
        {
            id: -1,
            text: "Sin tipo de evento",
            isChecked: this.props.filterEventType?.includes("Sin tipo de evento")
        },
    ];
    this.position = { X: 'Right', Y: 'Top' };
    this.listEventTypeDefault = null;
    this.listEventType = null
  }

  toastCusAnimation = {
    hide: { duration: "1" },
    show: { duration: "200" },
  };
 
  onDataBinding(items) {
    if (items.length > 0) {
      const newEventTypeData = [];
      for (let i = 0; i < items.length; i++) {
        let evt = items[i];
        newEventTypeData.push({
          id: evt.id,
          text: evt.text,
          isChecked: this.props.filterEventType?.includes(evt.text),
          color: evt.backgroundColor,
        });
      }
      this.setState({ eventTypeData: newEventTypeData });
    }
  }

  componentDidUpdate() {
    if(this.listEventTypeDefault?.dataSource.length > 0) {
      console.log(this.listEventTypeDefault?.getSelectedItems())
    }
    if(this.listEventType?.dataSource.length > 0) {
      console.log(this.listEventType?.getSelectedItems())
    }
  }


  componentDidMount() {
    this.onDataBinding(this.props.eventTypes || [] );
  }

  onSelect() {    
    // Get currently selected items
    const selectedItems = this.listEventType.curUL ? this.listEventType?.getSelectedItems()?.data : [];
    const selectedIds = selectedItems.map(item => item.id);
    
    // Update eventTypeData with current selection status
    const updatedEventTypeData = this.state.eventTypeData.map(item => ({
      ...item,
      isChecked: selectedIds.includes(item.id)
    }));
    
    // Update state with selection status
    this.setState({ 
      eventTypeData: updatedEventTypeData,
      allSelected: ((this.listEventType?.dataSource.length > 0 ? selectedItems.length : 0) === this.state.eventTypeData.length &&
        this.listEventTypeDefault?.getSelectedItems()?.data?.length === this.defaultEventTypeData.length)
    });
  }

  LineSeparator(){
    return (
        <div className="lineSeparator" />
    )
  }

  CustomHeader({text}){
    return(
        <div className="customHeader">
            {text}
       </div>
    )
  }

  listTemplate(data) {
    return (
      <div className="event-type-item">
        <div 
          style={{ border: `2px solid ${data.color}`}}
          className="dot-container">
          <span
            style={{ backgroundColor: data.color}}
            className="dot-filter-eventtype"
          ></span>
        </div>
        <div className="d-flex justify-content-between align-items-center w-100 ml-2">
          <span className="inter-regular-12 text-color-grey-800">
            {data.text}
          </span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="
        filter-event-type-row 
        custom-margin
        custom-padding-5
        material2
        modal-eventtype-container"
      >
        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <h3 className="inter-regular-14 text-color-grey-800 my-4">
              <span>
                {i18n.t("eventtype.filter_title_text")}
              </span>
              <span
                className="link-class"
                onClick={this.props.openEventTypes}
              >
                {i18n.t("eventtype.filter_title_text_complement")}
              </span>.
            </h3>
              <div>
                <div className="headerCheckBox">
                  <CheckBoxComponent 
                    change={() => {
                      if (this.listEventType && this.listEventTypeDefault) {
                        if ((this.listEventType?.dataSource.length > 0 ? this.listEventType.getSelectedItems()?.data?.length : 0) === this.state.eventTypeData.length &&
                        this.listEventTypeDefault.getSelectedItems()?.data?.length === this.defaultEventTypeData.length) {
                          // Uncheck all
                          if (this.listEventType?.dataSource.length > 0) {
                            this.listEventType.uncheckAllItems();
                          }
                          this.listEventTypeDefault.uncheckAllItems();
                          
                          // Update state
                          const updatedEventTypeData = this.state.eventTypeData.map(item => ({
                            ...item,
                            isChecked: false
                          }));
                          
                          this.setState({
                            allSelected: false,
                            eventTypeData: updatedEventTypeData
                          });
                        } else {
                          // Check all
                          if (this.listEventType?.dataSource.length > 0) {
                            this.listEventType.checkAllItems();
                          }
                          this.listEventTypeDefault.checkAllItems();
                          
                          // Update state
                          const updatedEventTypeData = this.state.eventTypeData.map(item => ({
                            ...item,
                            isChecked: true
                          }));
                          
                          this.setState({
                            allSelected: true,
                            eventTypeData: updatedEventTypeData
                          });
                        }
                      }
                    }} 
                    checked={this.state.allSelected}
                    label={i18n.t("eventtype.selectAll")}
                  />
                </div>
                <div>
                  <this.LineSeparator/>
                  <div className="customListsContainer">
                    <ListViewComponent
                      className="customListViewComponent"
                      id="filter-list"
                      dataSource={this.state.eventTypeData}
                      template={this.listTemplate.bind(this)}
                      ref={(listview) => {
                        this.listEventType = listview;
                      }}
                      showCheckBox={true} 
                      select={this.onSelect.bind(this)}
                    />
                    <ListViewComponent
                        className="customListViewComponent2"
                        id="filter-list"
                        dataSource={this.defaultEventTypeData}
                        ref={(listview) => {
                            this.listEventTypeDefault = listview;
                        }}
                        showCheckBox={true} 
                        select={this.onSelect.bind(this)}
                    />
                  </div>
                </div>
              <div className="e-footer-content">
              {(this.listEventType?.dataSource.length > 0 ? this.listEventType?.getSelectedItems()?.data.length : 0) <= 0 && this.listEventTypeDefault?.getSelectedItems()?.data.length <= 0 && <span style={{color: "red"}} > {i18n.t("eventtype.noFilterSelected")}</span>}
                 <div className="mt-5 mb-4 btn-action-container">
                    <Button
                      className="btn-outline-primary inter-semibold-14"
                      title={i18n.t("general.cancel")}
                      color="secondary"
                      onClick={() => this.props.cancel()}
                      >
                      {i18n.t("general.cancel")}
                    </Button>
                    <Button
                      id="newevent"
                      disabled={(this.listEventType?.dataSource.length ? this.listEventType?.getSelectedItems()?.data.length : 0) <=0 && this.listEventTypeDefault?.getSelectedItems()?.data.length <=0 }
                      className="ml-2 inter-semibold-14"
                      color="primary"
                      title={i18n.t("eventtype.filter")}
                      onClick={() => {
                        if (this.listEventType && this.listEventTypeDefault) {
                          this.props.onFilterEventsByEventType([
                            ...(this.listEventType?.dataSource.length > 0 && this.listEventType.getSelectedItems() && Array.isArray(this.listEventType.getSelectedItems().data)
                              ? this.listEventType.getSelectedItems().data.map(item => item.text)
                              : []),
                            ...(this.listEventTypeDefault.getSelectedItems() && Array.isArray(this.listEventTypeDefault.getSelectedItems().data)
                              ? this.listEventTypeDefault.getSelectedItems().data.map(item => item.text)
                              : [])
                          ])
                        }
                      }}
                      ref={(scope) => {
                        this.addBtn = scope;
                      }}
                    >
                      {i18n.t("eventtype.filter")}
                    </Button>       
                  </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default FilterEventtype;
